import { useEffect, useState } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { AUTH_CHANGED_EVENT, isAdminLoggedIn } from './utils/authStorage';

// Pages
import AccidentReports from './pages/accidents/AccidentReports';
import ActiveManage from './pages/actives/ActiveManage';
import ActivesList from './pages/actives/ActivesList';
import ActivesView from './pages/actives/ActivesView';
import AdminApprovals from './pages/admins/AdminApprovals';
import EnrollmeAdmins from './pages/admins/EnrollmeAdmins';
import BookingDetail from './pages/bookings/BookingDetail';
import DispatchMap from './pages/operations/DispatchMap';
import HOSNotifications from './pages/operations/HOSNotifications';
import IntelligenceDashboard from './pages/operations/IntelligenceDashboard';
import BookingsCreate from './pages/bookings/BookingsCreate';
import BookingsList from './pages/bookings/BookingsList';
import Dashboard from './pages/Dashboard';
import Fares from './pages/Fares';
import Login from './pages/Login';
import ReportsDiagnostics from './pages/reports/Diagnostics';
import FinancialReport from './pages/reports/FinancialReport';
import PulseHistoryReport from './pages/reports/PulseHistoryReport';
import ReceiptGenerator from './pages/reports/ReceiptGenerator';
import ReportsBuilder from './pages/reports/ReportsBuilder';
import CompanySettings from './pages/settings/CompanySettings';
import DriverMessaging from './pages/settings/DriverMessaging';
import MotivationMessagesReport from './pages/reports/MotivationMessagesReport';
import InsuranceRemovalRequestsReport from './pages/reports/InsuranceRemovalRequestsReport';
import DriverSafetyReport from './pages/reports/DriverSafetyReport';
import PrivacyPolicy from './pages/PrivacyPolicy';
import Signup from './pages/Signup';

function App() {
  const [isLoggedIn, setIsLoggedIn] = useState(isAdminLoggedIn);

  useEffect(() => {
    const handleTokenChange = () => setIsLoggedIn(isAdminLoggedIn());
    window.addEventListener('storage', handleTokenChange);
    window.addEventListener(AUTH_CHANGED_EVENT, handleTokenChange);
    return () => {
      window.removeEventListener('storage', handleTokenChange);
      window.removeEventListener(AUTH_CHANGED_EVENT, handleTokenChange);
    };
  }, []);

  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/signup" element={<Signup />} />
      <Route path="/privacy" element={<PrivacyPolicy />} />
      {/* Protected routes */}
      <Route
        path="/"
        element={isLoggedIn ? <Dashboard /> : <Navigate to="/login" replace />} />
      <Route
        path="/admins"
        element={isLoggedIn ? <AdminApprovals /> : <Navigate to="/login" replace />} />
      <Route
        path="/enrollme-admins"
        element={isLoggedIn ? <EnrollmeAdmins /> : <Navigate to="/login" replace />} />
      <Route
        path="/operations/dispatch"
        element={isLoggedIn ? <DispatchMap /> : <Navigate to="/login" replace />} />
      <Route
        path="/operations/intelligence"
        element={isLoggedIn ? <IntelligenceDashboard /> : <Navigate to="/login" replace />} />
      <Route
        path="/operations/intelligence/hos-notifications"
        element={isLoggedIn ? <HOSNotifications /> : <Navigate to="/login" replace />} />
      <Route
        path="/actives"
        element={isLoggedIn ? <ActivesList /> : <Navigate to="/login" replace />} />
      <Route
        path="/actives/new"
        element={isLoggedIn ? <ActiveManage /> : <Navigate to="/login" replace />} />
      <Route
        path="/actives/:id"
        element={isLoggedIn ? <ActiveManage /> : <Navigate to="/login" replace />} />
      <Route
        path="/actives/:id/view"
        element={isLoggedIn ? <ActivesView /> : <Navigate to="/login" replace />} />
      <Route
        path="/bookings"
        element={isLoggedIn ? <BookingsList /> : <Navigate to="/login" replace />} />
      <Route
        path="/bookings/new"
        element={isLoggedIn ? <BookingsCreate /> : <Navigate to="/login" replace />} />
      <Route
        path="/bookings/:id"
        element={isLoggedIn ? <BookingDetail /> : <Navigate to="/login" replace />} />
      <Route
        path="/fares"
        element={isLoggedIn ? <Fares /> : <Navigate to="/login" replace />} />
      <Route
        path="/settings/app"
        element={isLoggedIn ? <Navigate to="/fares" replace /> : <Navigate to="/login" replace />} />
      <Route
        path="/reports/builder"
        element={isLoggedIn ? <ReportsBuilder /> : <Navigate to="/login" replace />} />
      <Route
        path="/reports/receipts"
        element={isLoggedIn ? <ReceiptGenerator /> : <Navigate to="/login" replace />} />
      <Route
        path="/reports/diagnostics"
        element={isLoggedIn ? <ReportsDiagnostics /> : <Navigate to="/login" replace />} />
      <Route
        path="/reports/financials"
        element={isLoggedIn ? <FinancialReport /> : <Navigate to="/login" replace />} />
      <Route
        path="/reports/pulse"
        element={isLoggedIn ? <PulseHistoryReport /> : <Navigate to="/login" replace />} />
      <Route
        path="/settings/company"
        element={isLoggedIn ? <CompanySettings /> : <Navigate to="/login" replace />} />
      <Route
        path="/settings/messaging"
        element={isLoggedIn ? <DriverMessaging /> : <Navigate to="/login" replace />} />
      <Route
        path="/settings/safety-message"
        element={isLoggedIn ? <Navigate to="/reports/driver-safety?tab=login-message" replace /> : <Navigate to="/login" replace />} />
      <Route
        path="/reports/driver-safety"
        element={isLoggedIn ? <DriverSafetyReport /> : <Navigate to="/login" replace />} />
      <Route
        path="/reports/safety-acknowledgements"
        element={isLoggedIn ? <Navigate to="/reports/driver-safety?tab=acknowledgements" replace /> : <Navigate to="/login" replace />} />
      <Route
        path="/reports/motivation-messages"
        element={isLoggedIn ? <MotivationMessagesReport /> : <Navigate to="/login" replace />} />
      <Route
        path="/reports/insurance-removal"
        element={isLoggedIn ? <InsuranceRemovalRequestsReport /> : <Navigate to="/login" replace />} />
      <Route
        path="/accidents"
        element={isLoggedIn ? <AccidentReports /> : <Navigate to="/login" replace />} />
      <Route
        path="*"
        element={<Navigate to={isLoggedIn ? '/' : '/login'} replace />} />
    </Routes>
  );
}

export default App;
